export { default as ModalInput } from "./view"
